import { createFileRoute } from '@tanstack/react-router'

import { OnboardingWizard } from '@/features/onboarding/components/onboarding-wizard'

export const Route = createFileRoute('/_authed/onboarding')({
  component: () => <OnboardingWizard />,
})
